import { ImgSizeSpecs } from './ImgSizeSpecs';
import { addImage } from './actions';
import { addImageAction } from './const';
export const ImgSize = (builder, opts) => {
    builder.use(ImgSizeSpecs, opts);
    builder.addAction(addImageAction, ({ schema }) => addImage(schema));
};
